import { ReactElement } from 'react'
import { LogoWrap, StyledSvg } from './PriceIndicator.styled'
interface BJFLogoI {
  isCollapsed: boolean
  loading?: boolean
  children?: ReactElement
}

export const BJFLogo = ({ isCollapsed, loading }: BJFLogoI) => {
  return (
    <LogoWrap $isCollapsed={isCollapsed}>
      <StyledSvg $loading={loading} width="20" height="27" viewBox="0 0 20 27" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient
            id="paint0_linear_401_154"
            x1="9.72701"
            y1="0"
            x2="9.72701"
            y2="26.6975"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#34C1CE" />
            <stop offset="1" stopColor="#00D595" />
          </linearGradient>
          <linearGradient
            id="hoverGradient"
            x1="9.72701"
            y1="0"
            x2="9.72701"
            y2="26.6975"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00D595" />
            <stop offset="1" stopColor="#34C1CE" />
          </linearGradient>
        </defs>
        <path
          d="M19.3992 3.88228V0H7.49638C5.08291 0 3.27281 0.367988 2.10264 1.08557C0.932477 1.80314 0.347393 2.92551 0.347393 4.47106C0.347393 5.48302 0.603367 6.3294 1.11532 7.04697C1.62726 7.76455 2.30377 8.22454 3.14482 8.42693V8.55573C2.04779 8.85012 1.2433 9.3469 0.749638 10.0277C0.255974 10.7085 0 11.61 0 12.6956C0 14.3147 0.603367 15.6027 1.82839 16.5411C3.03512 17.4794 4.69895 17.9394 6.8016 17.9394H8.90424V19.7426C8.90424 20.9201 8.73969 21.7297 8.39229 22.2265C8.0449 22.7049 7.4781 22.9441 6.69189 22.9441C6.3445 22.9441 6.03367 22.9073 5.74113 22.8521C5.44859 22.7969 5.17433 22.7417 4.91836 22.6865V26.44C5.70456 26.6055 6.54562 26.6975 7.42325 26.6975C9.52589 26.6975 11.1166 26.072 12.1771 24.8208C13.2375 23.5696 13.7677 21.7297 13.7677 19.3194V11.2052H18.9969V7.32297H13.7677V3.90068H19.454L19.3992 3.88228ZM7.55123 3.66148H8.86767V6.88138H7.44153C6.74674 6.88138 6.21651 6.73419 5.83255 6.45819C5.44859 6.1822 5.26575 5.74062 5.26575 5.18863C5.26575 4.17667 6.01539 3.67988 7.53295 3.67988L7.55123 3.66148ZM4.95493 12.2724C4.95493 11.6652 5.15605 11.2236 5.55829 10.8925C5.96054 10.5797 6.54562 10.4141 7.31354 10.4141H8.88595V14.1859H7.22212C5.72285 14.1859 4.97321 13.542 4.97321 12.2724H4.95493Z"
          fill="url(#paint0_linear_401_154)"
        />
      </StyledSvg>
    </LogoWrap>
  )
}
